import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "297",
  "slug": "spot-ukraine-from-satellite-imagery",
  "title": "How to Recognise Ukraine in Satellite Images",
  "excerpt": "Much of Ukraine consists of plains and agricultural land, while the Carpathians enter the west.",
  "date": "2026-04-19",
  "category": "Geography",
  "series": "Spot the Country",
  "image": "/blog-images/ukraine.jpg",
  "readTime": "1 min",
  "content": [
    {
      "type": "paragraph",
      "text": "Much of Ukraine consists of plains and agricultural land, while the Carpathians enter the west. The Dnipro crosses the country towards the Black Sea. Large fields and river corridors can help describe the landscape, but they do not locate an image without wider context."
    },
    {
      "type": "heading",
      "text": "Broad plains and the Dnipro basin"
    },
    {
      "type": "paragraph",
      "text": "Trace the Dnipro in the historical overview and compare the plains with the Carpathian edge. The 2004 mosaic predates recent destruction and infrastructure changes."
    },
    {
      "type": "heading",
      "text": "Similar landscapes across borders"
    },
    {
      "type": "paragraph",
      "text": "Agricultural plains continue across neighbouring countries. Field size is not uniquely Ukrainian. Image date matters particularly here: war damage and changes to reservoirs mean older imagery cannot establish present conditions."
    }
  ],
  "imageAlt": "Ukraine regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
